import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('ExplorableExercise', LATEST_SCHEMA_VERSION.ExplorableExercise);
export default exerciseTypeVersionAdapter;